function readJsonElement(elementId) {
    const el = document.getElementById(elementId);
    if (!el || !el.textContent) {
        return null;
    }
    try {
        return JSON.parse(el.textContent);
    } catch (error) {
        return null;
    }
}

function readMemberBarControlConfig() {
    return readJsonElement('member-bar-control-config');
}

export function requireMemberBarControlConfig() {
    const cfg = readMemberBarControlConfig();
    if (!cfg || typeof cfg !== 'object') {
        throw new Error('requireMemberBarControlConfig: #member-bar-control-config is required');
    }
    return cfg;
}

function isTruthyFlag(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}

function isKioskValidatedFromDom() {
    const configs = [
        readJsonElement('bottomBarConfig'),
        readMemberBarControlConfig(),
        readJsonElement('kiosk-index-config'),
        readJsonElement('manager-index-config'),
    ];
    const fromConfig = configs.some(function (cfg) {
        return cfg && (isTruthyFlag(cfg.kioskValidated) || isTruthyFlag(cfg.isKioskValidated));
    });
    if (fromConfig) {
        return true;
    }
    const meta = document.querySelector('meta[name="manager-kiosk-no-print"]');
    return meta !== null && meta.getAttribute('content') === '1';
}

export function getKioskConfig() {
    const cfg = readJsonElement('bottomBarConfig') || readMemberBarControlConfig() || {};
    return {
        kioskValidated: isKioskValidatedFromDom(),
        minTransAmt: Number(cfg.minTransAmt) || 1,
        surchargeOptionOn: Boolean(cfg.surchargeOptionOn),
        surchargeAmt: cfg.surchargeAmt,
        congregationId: cfg.congregationId,
    };
}

export function isKioskVirtualKeyboardEnabled() {
    return getKioskConfig().kioskValidated;
}
